import { Drawer, Link } from '@lounge-fe/ui-kit'
import type { HomeNavigationProps } from './types'
import { Header } from './Header'
import { CountrySelector } from './CountrySelector'
import { useMutation } from '@tanstack/react-query'
import { useAuth } from '@lounge-fe/auth'
import { useTranslation } from 'react-i18next'
import { useShopify } from '@/hooks/useShopify'
import { HomeNavigationLink } from './HomeNavigationLink'

export const HomeNavigation: React.FC<HomeNavigationProps> = ({
  menuItems,
  drawerFooterMenu,
}) => {
  const { status, logout } = useAuth() // Get authentication state and logout function
  const { t } = useTranslation()
  const { routes } = useShopify()

  const { mutate: handleLogout, isPending: isLogoutLoading } = useMutation({
    mutationFn: logout,
  })

  return (
    <>
      <Header />
      <Drawer.Body as="nav" className="sm:px-10 sm:py-10">
        <ul className="flex flex-col items-start gap-y-8">
          {menuItems
            ? menuItems.map((menuItem) => (
                <HomeNavigationLink key={menuItem.title} menuItem={menuItem} />
              ))
            : undefined}
        </ul>
        <hr className="my-10" />
        <ul className="flex flex-col items-start gap-y-4">
          {status === 'authenticated' ? (
            <>
              <Link
                href={routes.account_url}
                className="w-full"
                variant="body-sm"
              >
                {t('account.details.title')}
              </Link>
            </>
          ) : (
            <Link
              href={routes.account_login_url}
              className="w-full"
              variant="body-sm"
            >
              {t('account.login')}
            </Link>
          )}
          {drawerFooterMenu
            ? drawerFooterMenu.map(({ title, url }) => (
                <Link
                  href={url}
                  key={title}
                  className="w-full"
                  variant="body-sm"
                >
                  {title}
                </Link>
              ))
            : undefined}

          {status === 'authenticated' && (
            <Link
              onClick={() => handleLogout()}
              variant="body-sm"
              className="cursor-pointer"
            >
              {t('action.sign_out')}
            </Link>
          )}
          <CountrySelector />
        </ul>
      </Drawer.Body>
    </>
  )
}
